












import { Component, mixins } from 'nuxt-property-decorator'
import { defineComponent } from '@nuxtjs/composition-api'
import { SectionCore } from '@/mixins/sectionCore'
import SectionBasic from '@/components/SectionBasic.vue'
import BlockBannerText from '@/components/BlockBannerText.vue'

@Component
class SectionBanner extends mixins(SectionCore) {}

export default defineComponent({
  name: 'SectionBanner',
  components: { SectionBasic, BlockBannerText },
  props: SectionBanner.options.props,
  setup() {},
})
